
// src/actions/react-chat.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const REACT_CHAT = "REACT_CHAT"
export const REACT_CHAT_REQUESTED = "REACT_CHAT_REQUESTED"
export const REACT_CHAT_COMPLETED = "REACT_CHAT_COMPLETED"
export const REACT_CHAT_FAILED = "REACT_CHAT_FAILED"
export const DELETE_REACT_CHAT = "DELETE_REACT_CHAT"
export const DELETE_REACT_CHAT_REQUESTED = "DELETE_REACT_CHAT_REQUESTED"
export const DELETE_REACT_CHAT_COMPLETED = "DELETE_REACT_CHAT_COMPLETED"
export const DELETE_REACT_CHAT_FAILED = "DELETE_REACT_CHAT_FAILED"

export function reactChatRequested() {
  return {
    type: REACT_CHAT_REQUESTED
  }
}

export function reactChat(chat_room_id, message_id, like_type) {
  return function(dispatch) {
    dispatch(reactChatRequested())
    return api.post(`/react_chat`, { chat_room_id, message_id, like_type })
        .then((result)=> {
          dispatch(reactChatCompleted(result, chat_room_id, message_id))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(reactChatFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function reactChatCompleted(result, chat_room_id, message_id) {
  const offset = message_id
  const results = [{...result}]
  return {
    type: REACT_CHAT_COMPLETED,
    results, 
    offset,
    chat_room_id
  }
}

export function reactChatFailed(error) {
  return {
    type: REACT_CHAT_FAILED,
    error,
  }
}

export function deleteReactChatRequested() {
  return {
    type: DELETE_REACT_CHAT_REQUESTED
  }
}

export function deleteReactChat(chat_room_id, message_id, like_id) {
  return function(dispatch) {
    dispatch(deleteReactChatRequested())
    return api.delete(`/react_chat/${like_id}`)
        .then((results)=> {
          dispatch(deleteReactChatCompleted(results, chat_room_id, message_id))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteReactChatFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteReactChatCompleted(result, chat_room_id, message_id) {
  const offset = message_id
  const results = [{...result}]
  return {
    type: DELETE_REACT_CHAT_COMPLETED,
    results,
    offset,
    chat_room_id
  }
}

export function deleteReactChatFailed(error) {
  return {
    type: DELETE_REACT_CHAT_FAILED,
    error,
  }
}


// WEBPACK FOOTER //
// ./src/actions/react-chat.js